export type TourStepDef = {
  /** data-tour attribute value on the target element, or null for center modal */
  target: string | null;
  title: string;
  description: string;
  /** If true, this step requires a special "I Acknowledge" action instead of "Next" */
  requiresAcknowledgment?: boolean;
};

export const TOUR_STEPS: TourStepDef[] = [
  {
    target: null,
    title: "Welcome to cradleOS!",
    description: "Let's take a quick tour of your dashboard.",
  },
  {
    target: null,
    title: "Acceptable Use Acknowledgment",
    description: "Please review the policy below.",
    requiresAcknowledgment: true,
  },
  {
    target: "families",
    title: "Families",
    description:
      "Manage your students, track attendance, communicate with parents, and log daily activities.",
  },
  {
    target: "employees",
    title: "Employees",
    description:
      "View your staff directory, monitor who's clocked in, and track certifications.",
  },
  {
    target: "billing",
    title: "Billing",
    description:
      "Create invoices, track payments, and manage your Stripe integration.",
  },
  {
    target: "classrooms",
    title: "Classrooms",
    description:
      "Monitor real-time staff-to-child ratios across all your classrooms.",
  },
  {
    target: "search",
    title: "Search",
    description:
      "Quickly find any child, family, or staff member. Use \u2318K for instant access.",
  },
  {
    target: "user-menu",
    title: "Your Profile",
    description:
      "Access your profile, center settings, and app preferences here.",
  },
  {
    target: null,
    title: "You're all set!",
    description: "Your dashboard is ready. Click any card to dive in.",
  },
];
